import { BiGroup, BiLocationPlus, BiNote, BiStar, BiUser } from "react-icons/bi";
import { FaNetworkWired, FaRegBuilding } from "react-icons/fa";
import { IoWarningOutline } from "react-icons/io5";
import { RiComputerLine, RiWallet2Line } from "react-icons/ri";
import { NavLink } from "react-router-dom";

const SidebarContent = ({ role, itemBase, iconCol, labelBase, expanded }) => (

    <nav className="mt-2">

        {role === "ADMIN" && (
            <>
                {/* DASHBOARD */}
                <NavLink
                    to="/smartcity/admin/dashboard"
                    className={({ isActive }) =>
                        `${itemBase} ${isActive
                            ? "bg-[#3f4db3]"
                            : "hover:bg-[#4a58b8]"
                        }`
                    }
                >
                    <div className={iconCol}>
                        <RiComputerLine size={24} />
                    </div>

                    <span
                        className={`${labelBase} ${expanded ? "opacity-100" : "opacity-0"
                            }`}
                    >
                        Dashboard
                    </span>
                </NavLink>

                <NavLink
                    to="/smartcity/admin/departments"
                    className={({ isActive }) =>
                        `${itemBase} ${isActive
                            ? "bg-[#3f4db3]"
                            : "hover:bg-[#4a58b8]"
                        }`
                    }
                >
                    <div className={iconCol}>
                        <FaRegBuilding size={24} />
                    </div>
                    <span
                        className={`${labelBase} ${expanded ? "opacity-100" : "opacity-0"
                            }`}
                    >
                        Department
                    </span>
                </NavLink>

                <NavLink
                    to="/smartcity/admin/designations"
                    className={({ isActive }) =>
                        `${itemBase} ${isActive
                            ? "bg-[#3f4db3]"
                            : "hover:bg-[#4a58b8]"
                        }`
                    }
                >
                    <div className={iconCol}>
                        <BiStar size={24} />
                    </div>
                    <span
                        className={`${labelBase} ${expanded ? "opacity-100" : "opacity-0"
                            }`}
                    >
                        Designation
                    </span>
                </NavLink>

                <NavLink
                    to="/smartcity/admin/employees"
                    className={({ isActive }) =>
                        `${itemBase} ${isActive
                            ? "bg-[#3f4db3]"
                            : "hover:bg-[#4a58b8]"
                        }`
                    }
                >
                    <div className={iconCol}>
                        <BiUser size={24} />
                    </div>
                    <span
                        className={`${labelBase} ${expanded ? "opacity-100" : "opacity-0"
                            }`}
                    >
                        Employees
                    </span>
                </NavLink>

                <NavLink
                    to="/smartcity/admin/wards"
                    className={({ isActive }) =>
                        `${itemBase} ${isActive
                            ? "bg-[#3f4db3]"
                            : "hover:bg-[#4a58b8]"
                        }`
                    }
                >
                    <div className={iconCol}>
                        <RiWallet2Line size={24} />
                    </div>
                    <span
                        className={`${labelBase} ${expanded ? "opacity-100" : "opacity-0"
                            }`}
                    >
                        Ward
                    </span>
                </NavLink>

                <NavLink
                    to="/smartcity/admin/committees"
                    className={({ isActive }) =>
                        `${itemBase} ${isActive
                            ? "bg-[#3f4db3]"
                            : "hover:bg-[#4a58b8]"
                        }`
                    }
                >
                    <div className={iconCol}>
                        <BiGroup size={24} />
                    </div>
                    <span
                        className={`${labelBase} ${expanded ? "opacity-100" : "opacity-0"
                            }`}
                    >
                        Committee
                    </span>
                </NavLink>


                <NavLink
                    to="/smartcity/admin/work-types"
                    className={({ isActive }) =>
                        `${itemBase} ${isActive
                            ? "bg-[#3f4db3]"
                            : "hover:bg-[#4a58b8]"
                        }`
                    }
                >
                    <div className={iconCol}>
                        <FaNetworkWired size={24} />
                    </div>
                    <span
                        className={`${labelBase} ${expanded ? "opacity-100" : "opacity-0"
                            }`}
                    >
                        Work Type
                    </span>
                </NavLink>

                <NavLink
                    to="/smartcity/admin/tender-types"
                    className={({ isActive }) =>
                        `${itemBase} ${isActive
                            ? "bg-[#3f4db3]"
                            : "hover:bg-[#4a58b8]"
                        }`
                    }
                >
                    <div className={iconCol}>
                        <BiNote size={24} />
                    </div>
                    <span
                        className={`${labelBase} ${expanded ? "opacity-100" : "opacity-0"
                            }`}
                    >
                        Tender Type
                    </span>
                </NavLink>

                <NavLink
                    to="/smartcity/admin/alert-types"
                    className={({ isActive }) =>
                        `${itemBase} ${isActive
                            ? "bg-[#3f4db3]"
                            : "hover:bg-[#4a58b8]"
                        }`
                    }
                >
                    <div className={iconCol}>
                        <IoWarningOutline size={24} />
                    </div>
                    <span
                        className={`${labelBase} ${expanded ? "opacity-100" : "opacity-0"
                            }`}
                    >
                        Alert Type
                    </span>
                </NavLink>

                <NavLink
                    to="/smartcity/admin/location"
                    className={({ isActive }) =>
                        `${itemBase} ${isActive
                            ? "bg-[#3f4db3]"
                            : "hover:bg-[#4a58b8]"
                        }`
                    }
                >
                    <div className={iconCol}>
                        <BiLocationPlus size={24} />
                    </div>
                    <span
                        className={`${labelBase} ${expanded ? "opacity-100" : "opacity-0"
                            }`}
                    >
                        Location
                    </span>
                </NavLink>


            </>
        )}
    </nav>
);

export default SidebarContent;

